
import { EmptyValue } from '../interpreter/InterpreterValue';
/**
 * Represents singleton vertex bound to all empty cells
 */
export class EmptyCellVertex {
    constructor() { }
    /**
     * Retrieves cell value bound to that singleton
     */
    getCellValue() {
        return EmptyValue;
    }
}
